import type { FacadeImprovementAttachment, UploadedFile } from '../../types';
import { AttachmentItem } from './AttachmentItem';

interface IAttachmentsProps {
  step5: Record<string, FacadeImprovementAttachment>;
  files: UploadedFile[];
}

export default function Attachments({ step5, files }: IAttachmentsProps) {
  const getFileUrl = (fileKey: string) => {
    const item = files.find((f) => f.key === fileKey);
    return item?.url || '';
  };

  return (
    <section>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>Attachments</h2>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-6'>
          <div className='space-y-6'>
            <div className='grid grid-cols-2 gap-x-4 gap-y-8'>
              <div>
                <AttachmentItem title='Drawing and Specifications' getFileUrl={getFileUrl} {...step5.f1} />
              </div>
              <div className='sm:col-span-1'>
                <AttachmentItem title='Building Photographs' getFileUrl={getFileUrl} {...step5.f2} />
              </div>
              <div className='sm:col-span-1'>
                <AttachmentItem title='Letters of commitment (others involved in financing)' getFileUrl={getFileUrl} {...step5.f3} />
              </div>
              <div className='sm:col-span-1'>
                <AttachmentItem title='Personal financial statements for each building owner.' getFileUrl={getFileUrl} {...step5.f4} />
              </div>
              {step5.w9Form && (
                <div className='sm:col-span-1'>
                  <AttachmentItem title='W-9 Form' getFileUrl={getFileUrl} {...step5.w9Form} />
                </div>
              )}
              {step5.transparencyForm && (
                <div className='sm:col-span-1'>
                  <AttachmentItem title='Transparency Form' getFileUrl={getFileUrl} {...step5.transparencyForm} />
                </div>
              )}
              {step5.businessLicense && (
                <div className='sm:col-span-1'>
                  <AttachmentItem title='Business License' getFileUrl={getFileUrl} {...step5.businessLicense} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
